import SeverityTagComponent from './SeverityTag'
export { SeverityTag } from './SeverityTag'
export default SeverityTagComponent
